import { format } from "sql-formatter";
import { DataStoreReqEndPointLogic } from "../../../../logic/Admin/DataStoreRequest/DataStoreRequestEndPointLogic";

export interface PlaceholderValidationResult {
  isValid: boolean;
  placeholders?: string[];
  count?: number;
}

export const fetchBizLayerQuery = async (
  token: any,
  dispatch: any,
  setIsLoading: (value: boolean) => void
) => {
  try {
    await DataStoreReqEndPointLogic.getBizLayerQuery(
      token,
      dispatch,
      setIsLoading
    );
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export interface PlaceholderValidationResult {
  isValid: boolean;
  placeholders?: string[];
  count?: number;
  replacedSql?: string;
}

export interface PlaceholderValidationResult {
  isValid: boolean;
  placeholders?: string[];
  count?: number;
  replacedSql?: string;
}

export interface PlaceholderValidationResult {
  isValid: boolean;
  placeholders?: string[];
  count?: number;
  replacedSql?: string;
}

export const validatePlaceholders = (
  sql: string
): PlaceholderValidationResult => {
  const placeholderRegex = /{{(.*?)}}/g;
  const matches = [...sql.matchAll(placeholderRegex)];

  // Step 1: Replace known DB values with placeholders
  let replacedSql = sql
    .replace(/\bOptival_bigquery_DB\b/g, "{{var:db_name}}")
    .replace(/\bbigq_staging\b/g, "{{var:db_name}}");

  // Step 2: Strip FORMAT("...", ...) → extract inner expression only
  replacedSql = replacedSql.replace(
    /FORMAT\(\s*(['"]).*?\1\s*,\s*((?:CAST\([^()]+\s+AS\s+\w+\))|(?:CAST\([^()]+\))|(?:floor\([^()]+\))|(?:CAST\(floor\([^()]+\)\)))\s*\)/g,
    (_, _formatString, innerExpr) => innerExpr
  );

  if (matches.length > 0) {
    const allPlaceholders = matches.map((match) => match[1]);
    const filteredPlaceholders = allPlaceholders.filter(
      (ph) => ph !== "var:db_name"
    );
    const uniquePlaceholders = [...new Set(filteredPlaceholders)];

    return {
      isValid: true,
      placeholders: uniquePlaceholders,
      count: matches.length,
      replacedSql,
    };
  }

  return {
    isValid: false,
    replacedSql,
  };
};

function formatValue(value: string, format: string): string {
  if (format === "string" || format === "date") {
    return `'${value}'`;
  }
  if (format === "number") {
    return value;
  }
  return value; // fallback (could expand for "boolean" or "json", etc.)
}

export function replaceCustomPlaceholders(
  requestSql: any,
  createQueryFormDataInput: any,
  env: any
) {
  const placeholderRegex = /{{\s*(?!var:)([^}]+)\s*}}/g;
  const dbNameRegex = /{{\s*var:db_name\s*}}/g;

  const seen = new Map();
  let defaultIndex = 0;

  let updatedSql = typeof requestSql === "string" ? requestSql : "";

  // First, handle general placeholders
  updatedSql = updatedSql.replace(
    placeholderRegex,
    (match: any, placeholder: any) => {
      placeholder = placeholder.trim();

      if (!seen.has(placeholder)) {
        const defaultValue =
          createQueryFormDataInput[`${defaultIndex}-value_for_test`];
        const format = createQueryFormDataInput[`${defaultIndex}-format`];

        let formattedValue = defaultValue;

        if (Array.isArray(defaultValue)) {
          formattedValue = defaultValue.map((val) => `'${val}'`).join(", ");
        } else {
          formattedValue = formatValue(defaultValue, format);
        }
        seen.set(placeholder, formattedValue);
        defaultIndex++;
      }

      return seen.get(placeholder) ?? match;
    }
  );

  // Handle {{var:db_name}} replacement
  const dbNameReplacement =
    env === "staging" || env === "development"
      ? "bigq_staging"
      : "Optival_bigquery_DB";
  updatedSql = updatedSql.replace(dbNameRegex, dbNameReplacement);

  // --- Additional SQL processing ---
  // FORMAT("%'d", CAST(floor(...)) → floor(...)
  updatedSql = updatedSql.replace(
    /FORMAT\("%'d",\s*CAST\(floor\((.*?)\)\s*AS\s*int64\)\)/gi,
    "floor($1)"
  );

  // FORMAT("%'d", CAST(...)) → CAST(... AS int64)
  updatedSql = updatedSql.replace(
    /FORMAT\("%'d",\s*CAST\((.*?)\s*AS\s*int64\)\)/gi,
    "CAST($1 AS int64)"
  );

  // Remove empty lines & trim each line
  updatedSql = updatedSql
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line)
    .join(" ");

  // Final cleanup
  updatedSql = updatedSql
    // Match %something% but not %%something%%
    .replace(/(?<!%)%([^%]+)%(?!%)/g, "%%$1%%")
    // Remove line breaks
    .replace(/\s*\n\s*/g, " ")
    // Collapse multiple spaces
    .replace(/\s+/g, " ")
    .trim(); // escape %
  updatedSql = updatedSql.replace(/\t/g, " "); // tabs → spaces
  updatedSql = updatedSql.split(/\s+/).join(" "); // collapse multiple spaces
  updatedSql = updatedSql.trim();

  return updatedSql;
}

export function replaceCustomPlaceholdersEdit(
  requestSql: any,
  createQueryFormDataInput: any,
  env: any
) {
  const placeholderRegex = /{{\s*(?!var:)([^}]+)\s*}}/g;
  const dbNameRegex = /{{\s*var:db_name\s*}}/g;

  const seen = new Map();
  let defaultIndex = 0;

  let updatedSql = typeof requestSql === "string" ? requestSql : "";

  // First, handle general placeholders
  updatedSql = updatedSql.replace(
    placeholderRegex,
    (match: any, placeholder: any) => {
      placeholder = placeholder.trim();

      if (!seen.has(placeholder)) {
        const defaultValue =
          createQueryFormDataInput[`${defaultIndex}-value_for_test`];
        const format = createQueryFormDataInput[`${defaultIndex}-format`];

        let formattedValue = defaultValue;

        if (Array.isArray(defaultValue)) {
          formattedValue = defaultValue.map((val) => `'${val}'`).join(", ");
        } else {
          formattedValue = formatValue(defaultValue, format);
        }
        seen.set(placeholder, formattedValue);
        defaultIndex++;
      }

      return seen.get(placeholder) ?? match;
    }
  );

  // Handle {{var:db_name}} replacement
  const dbNameReplacement =
    env === "staging" || env === "development"
      ? "bigq_staging"
      : "Optival_bigquery_DB";
  updatedSql = updatedSql.replace(dbNameRegex, dbNameReplacement);

  // Handle FORMAT("%'d", CAST(floor(...)) → floor(...)
  updatedSql = updatedSql.replace(
    /FORMAT\("%'d",\s*CAST\(floor\((.*?)\)\s*AS\s*int64\)\)/gi,
    "floor($1)"
  );

  // Handle FORMAT("%'d", CAST(...)) → CAST(... AS int64)
  updatedSql = updatedSql.replace(
    /FORMAT\("%'d",\s*CAST\((.*?)\s*AS\s*int64\)\)/gi,
    "CAST($1 AS int64)"
  );

  // Remove empty lines & trim each line
  updatedSql = updatedSql
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line)
    .join(" ");

  // Final cleanup
  updatedSql = updatedSql
    // Match %something% but not %%something%%
    .replace(/(?<!%)%([^%]+)%(?!%)/g, "%%$1%%")
    // Remove line breaks
    .replace(/\s*\n\s*/g, " ")
    // Collapse multiple spaces
    .replace(/\s+/g, " ")
    .trim();
  updatedSql = updatedSql.replace(/\t/g, " ");
  updatedSql = updatedSql.split(/\s+/).join(" ");
  updatedSql = updatedSql.trim();

  return updatedSql;
}

export const handleChangeHelper = (
  dispatch: any,
  action: (payload: any) => any,
  key: string,
  value: any
) => {
  dispatch(action({ [key]: value }));
};

export const handleFormatHelper = (
  requestSql: string,
  onUpdate: (updatedSql: string) => void
) => {
  try {
    const placeholderMap: Record<string, string> = {};
    let tokenCounter = 0;

    const cleanedQuery = requestSql.replace(/{{.*?}}/g, (match: string) => {
      const token = `__PLACEHOLDER_${tokenCounter}__`;
      placeholderMap[token] = match;
      tokenCounter++;
      return token;
    });

    const formattedQuery = format(cleanedQuery, { language: "bigquery" });

    const restoredQuery = formattedQuery.replace(
      /__PLACEHOLDER_\d+__/g,
      (match) => {
        return placeholderMap[match];
      }
    );

    onUpdate(restoredQuery);
  } catch (error) {
    alert("Failed to format query. Please check for invalid syntax.");
  }
};

export const transformFormData = (formData: any) => {
  const result = [] as any;

  Object.entries(formData).forEach(([key, value]) => {
    const [index, field] = key.split("-");
    if (!result[index]) result[index] = { fields: [] };

    if (["title", "description"].includes(field)) {
      result[index][field] = value;
    } else {
      result[index].fields.push({
        label: field,
        value: value,
      });
    }
  });

  return result;
};

export const transformFormDataEdit = (formData: any) => {
  const result = [] as any;

  Object.entries(formData).forEach(([_, value]: [string, any]) => {
    result.push({
      title: value.title || "",
      description: value.description || "",
      fields: [
        {
          label: "type",
          value: value.type || "",
        },
        {
          label: "order",
          value: value.order || "",
        },
      ],
    });
  });

  return result;
};

export const buildAndDispatchCreate = (
  createQueryFormData: any,
  placeholders: any,
  createQueryFormDataInput: any,
  outputValues: any
) => {
  const placeholderKeys = placeholders?.placeholders;

  const inputProperties: Record<string, any> = {};
  const outputProperties: Record<string, any> = {};

  placeholderKeys.forEach((placeholder: string, index: number) => {
    const format = createQueryFormDataInput[`${index}-format`] || "";
    const rawValue = createQueryFormDataInput[`${index}-value_for_test`];

    let formattedValue: string | string[] = rawValue;

    // Apply quoting logic
    if (Array.isArray(rawValue)) {
      formattedValue = rawValue.map((val) => formatValue(val, format));
    } else {
      formattedValue = formatValue(rawValue, format);
    }

    const field: Record<string, any> = {
      title: createQueryFormDataInput[`${index}-title`],
      description: createQueryFormDataInput[`${index}-description`],
      format,
      order: Number(createQueryFormDataInput[`${index}-order`]),
      value_for_test: formattedValue,
    };

    if (format === "string" || format === "date") {
      field.type = "string";
    }
    if (format === "number") {
      field.type = "number";
    }

    inputProperties[placeholder] = field;
  });

  outputValues?.forEach((field: any) => {
    const { name, type, title, description, order } = field;

    const cleanProps: any = { type };

    if (title !== "null") cleanProps.title = title;
    if (description !== "null") cleanProps.description = description;
    if (order !== "null") cleanProps.order = order;

    outputProperties[name] = cleanProps;
  });

  return {
    description: createQueryFormData?.queryDescription,
    database: createQueryFormData?.database?.value,
    type: createQueryFormData?.type,
    created: createQueryFormData?.created,
    created_by: createQueryFormData?.created_by,
    // query: placeholders?.replacedSql.replace(/\s+/g, " ").trim(),
    query: placeholders?.replacedSql
      // match %something%
      ?.replace(
        /%([^%]+)%/g,
        (match: string, inner: string, offset: number, full: string) => {
          const before = full[offset - 1];
          const after = full[offset + match.length];
          // if already wrapped with %%
          return before === "%" || after === "%" ? match : `%%${inner}%%`;
        }
      )
      // remove all newlines and trim spaces around them
      ?.replace(/\s*\n\s*/g, " ")
      // collapse multiple spaces into one
      ?.replace(/\s+/g, " ")
      ?.trim(),
    name: createQueryFormData?.queryName,
    modules: createQueryFormData?.modules,
    confluence_url: createQueryFormData?.confluence_url,
    input: {
      type: "object",
      title: "Input Parameters",
      properties: inputProperties,
      required: placeholders?.placeholders,
    },
    output: {
      type: "object",
      properties: outputProperties,
    },
  };
};

export const buildAndDispatchEdit = (
  editQueryFormData: any,
  placeholders: any,
  editQueryFormDataInput: any,
  outputValues: any
) => {
  const placeholderKeys = placeholders?.placeholders;

  const inputProperties: Record<string, any> = {};
  const outputProperties: Record<string, any> = {};

  placeholderKeys.forEach((placeholder: string, index: number) => {
    const format = editQueryFormDataInput[`${index}-format`] || "";
    const rawValue = editQueryFormDataInput[`${index}-value_for_test`];

    let formattedValue: string | string[] = rawValue;

    // Apply quoting logic
    if (Array.isArray(rawValue)) {
      formattedValue = rawValue.map((val) => formatValue(val, format));
    } else {
      formattedValue = formatValue(rawValue, format);
    }
    const field: Record<string, any> = {
      title: editQueryFormDataInput[`${index}-title`],
      description: editQueryFormDataInput[`${index}-description`],
      format,
      order: Number(editQueryFormDataInput[`${index}-order`]),
      value_for_test: formattedValue,
    };

    // Determine type based on format
    if (format === "string" || format === "date") {
      field.type = "string";
    }
    if (format === "number") {
      field.type = "number";
    }
    // Do not set `type` for "array" format

    inputProperties[placeholder] = field;
  });

  outputValues?.forEach((field: any) => {
    const { name, type, title, description, order } = field;

    const cleanProps: any = { type };

    if (title !== "null") cleanProps.title = title;
    if (description !== "null") cleanProps.description = description;
    if (order !== "null") cleanProps.order = order;

    outputProperties[name] = cleanProps;
  });

  return {
    description: editQueryFormData?.description,
    database: editQueryFormData?.database,
    type: editQueryFormData?.type,
    created: editQueryFormData?.created,
    created_by: editQueryFormData?.created_by,
    modified: editQueryFormData?.modified,
    modified_by: editQueryFormData?.modified_by,
    query: placeholders?.replacedSql
      // Match %%something%%
      ?.replace(
        /%([^%]+)%/g,
        (match: string, inner: string, offset: number, full: string) => {
          const before = full[offset - 1];
          const after = full[offset + match.length];

          // Avoid double % overlaps (e.g. %%%%something%%%%)
          if (before === "%" || after === "%") {
            return match;
          }
          return `%%${inner}%%`; // wrap the inner part with double %%
        }
      )
      ?.replace(/\s*\n\s*/g, " ")
      // collapse multiple spaces into one
      ?.replace(/\s+/g, " ")
      ?.trim(),

    name: editQueryFormData?.name,
    modules: editQueryFormData?.modules,
    confluence_url: editQueryFormData?.confluence_url,
    input: {
      type: "object",
      title: "Input Parameters",
      properties: inputProperties,
      required: placeholders?.placeholders,
    },
    output: {
      type: "object",
      properties: outputProperties,
    },
  };
};

export function getCurrentUtcTime(): string {
  const now = new Date();
  return now.toISOString(); // Returns UTC in ISO 8601 format
}
export function formatUtcToHumanReadable(utcString: string): string {
  const date = new Date(utcString);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    timeZone: "UTC",
  };

  return date.toLocaleString("en-US", options) + " UTC";
}
